<template>
    <dropdown
        :value="value"
        :options="styleOptions"
        native
        @input="onInput"
    />
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'border-style',
    mixins: [baseOption],

    data() {
        return {
            defaultValue: 'solid',
            tailwindDefinitionProp: 'borderStyle',
            value: 'solid',

            styleOptions: [
                { text: 'Solid', value: 'solid' },
                { text: 'Dashed', value: 'dashed' },
                { text: 'Dotted', value: 'dotted' },
            ],
        };
    },

    methods: {
        onInput(valueNew) {
            const flexClassNew = this.addFlexClass({
                value: valueNew,
            });

            this.value = valueNew;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            const { value } = this.flexClassDefinition;

            this.value = value || this.defaultValue;
        },
    },
};
</script>
